var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useSubmitExternalMatchStats } from "../api/MatchApiProvider";
import { useRetrieveUserExternalMatchPermissions } from "../api/PermissionApiProvider";
import { useRetrieveExternalMatch } from "../api/MatchApiProvider";
import { useRetrievePlayersByTeamId, useRetrieveTeam } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { ExternalMatchStatsForm } from "./ExternalMatchStatsForm";
export var UpdatePlayerExternalMatchStats = function () {
    var id = useNumericParams().id;
    var navigate = useNavigate();
    var _a = useRetrieveUserExternalMatchPermissions({ externalMatchId: id }), userExternalMatchPermissions = _a.data, userExternalMatchPermissionsIsLoading = _a.isLoading, userExternalMatchPermissionsError = _a.error;
    var _b = (userExternalMatchPermissions || {}).canModify, canModify = _b === void 0 ? false : _b;
    var _c = useRetrieveExternalMatch({ id: id, enabled: canModify }), useRetrieveExternalMatchIsLoading = _c.isLoading, useRetrieveExternalMatchError = _c.error, externalMatch = _c.data;
    var _d = useRetrievePlayersByTeamId({ teamId: externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.team }), players = _d.data, playersError = _d.error, playersIsLoading = _d.isLoading;
    var _e = useRetrieveTeam({ id: externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.team }), team = _e.data, teamIsLoading = _e.isLoading, teamError = _e.error;
    var _f = useSubmitExternalMatchStats(externalMatch), submitStatsIsLoading = _f.isLoading, submitStatsIsError = _f.isError, submitStats = _f.mutateAsync;
    if (userExternalMatchPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (userExternalMatchPermissionsError) {
        return _jsx(ErrorView, { error: userExternalMatchPermissionsError });
    }
    if (!canModify) {
        return _jsx(NotFound, {});
    }
    if (submitStatsIsLoading ||
        playersIsLoading ||
        useRetrieveExternalMatchIsLoading ||
        teamIsLoading ||
        !externalMatch) {
        return _jsx(Loading, {});
    }
    if (useRetrieveExternalMatchError || playersError || teamError) {
        return _jsx(ErrorView, { error: useRetrieveExternalMatchError || playersError });
    }
    if (!team || !externalMatch || !players) {
        throw new Error("Team, external match, or players data is not available.");
    }
    var onSubmit = function (externalMatchResult, playerExternalMatchStats) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, submitStats({
                        result: {
                            teamScore: externalMatchResult.teamScore,
                            opponentTeamScore: externalMatchResult.opponentTeamScore,
                            matchReport: externalMatchResult.matchReport,
                            highlightsYoutubeUrl: externalMatchResult.highlightsYoutubeUrl,
                        },
                        playerStats: Object.values(playerExternalMatchStats),
                    })];
                case 1:
                    _a.sent();
                    navigate("/teams/".concat(externalMatch.team, "/external-matches/").concat(id, "/"));
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: submitStatsIsError, message: "Failed to update match stats! Please try again." }), _jsx(Typography, { variant: "h6", children: _jsxs("strong", { children: ["External Match Stats for ", team.name] }) }), _jsx(Typography, { variant: "subtitle2", children: format(new Date(externalMatch.kickOff), "MMMM do yyyy @ H:mma") }), _jsx(ExternalMatchStatsForm, { players: players, onSubmit: onSubmit, externalMatch: externalMatch, team: team })] }));
};
